import React, { useState, useEffect } from 'react'
import axios from 'axios'
import GameLaunch from './GameLaunch'
import { Container, CardGroup, Card, Grid, GridColumn, Input, Button, Icon, Divider, Header, Loader, Message } from 'semantic-ui-react'

const EDGame = ({ game, goBack }) => {
    const [isLoading, setIsLoading] = useState(true)
    const [isSearching, setIsSearching] = useState(false)
    const [searchString, setSearchString] = useState('')
    const [denoms, setDenoms] = useState([])
    const [fields, setFields] = useState([])
    const [servers, setServers] = useState(null)
    const [notes, setNotes] = useState('')
    const [launchedGames, setLaunchedGames] = useState([])
    const [isGameAlreadyLaunched, setIsGameAlreadyLaunched] = useState(true)
    const [isLaunchingGame, setIsLaunchingGame] = useState(false)
    const [isGameLaunched, setIsGameLaunched] = useState(false)
    
    useEffect(() => {
        const url1 = isDevelopmentServer() ? '/api/proxy/denominations/ed' : '/api/denominations/ed'
        axios.post(url1, { game }).then(res => {
            setIsLoading(false)
            if (res.data.code !== '403') setDenoms(Object.entries(res.data).map(([key, value]) => ({ key, value })))
        }).catch(err => alert('Fail to get ED denominations, please try again. Error: ' + err))

        const url2 = isDevelopmentServer() ? '/api/proxy/game_fields/ed' : '/api/game_fields/ed'
        axios.post(url2, { game }).then(res => {
            setFields(res.data.fields.fields)
            setNotes(res.data.fields.notes)
        }).catch(err => alert('Fail to get ED denominations, please try again. Error: ' + err))

        const url3 = isDevelopmentServer() ? '/api/proxy/server_list/ed' : '/api/server_list/ed'
        axios.post(url3, { game }).then(res => {
            if (!res.data.servers) return
            setServers(res.data.servers)
        })
    }, [game])

    useEffect(() => {
        axios.get('/api/launched_games').then((res) => setLaunchedGames(res.data))
    }, [])

    useEffect(() => {
        if (!launchedGames) return
        for (const launchedGame of launchedGames) {
            if (launchedGame.supplierName === game) {
                setIsGameAlreadyLaunched(true)
                return
            }
        }
        setIsGameAlreadyLaunched(false)
    }, [launchedGames, game])

    useEffect(() => {
        if (isLaunchingGame) {
          scrollToElement('scrollToHere')
        }
      }, [isLaunchingGame])

    const handleChangeSearchField = e => {
        const { value } = e.target
        if (value === '') {
            setIsSearching(false)
        } else {
            setIsSearching(true)
            setSearchString(value)
        }
    }
    const handleLaunchGameClicked = () => {
        setIsLaunchingGame(!isLaunchingGame)
    }
    const handleFinalLaunchClicked = async details => {
        const { name, tagline, gameCurrency, consumerMarkup, resellerMarkup, resellerMarkupAll, setForIndividualReseller } = details
        var gameItems = []
        for (const denom of denoms) {
            const itemName = /^\d+$/.test(denom.key) ? `${denom.key} ${gameCurrency}` : denom.key
            const gameItemDict = { cost: denom.value, nameConsumer: { header: itemName, subheader: '' }, nameReseller: itemName, nameSupplier: denom.key, isDiscountedConsumer: false, isDiscountedReseller: false, isHiddenConsumer: false, isHiddenReseller: false, 
                                    discountRateConsumer: 0, discountRateReseller: 0 }
            gameItems.push(gameItemDict)
        }
        const requiresServerID = fields.includes('serverid')
        const requiresCharacterName = fields.includes('charname')
        const convertedMarkup = Object.fromEntries(Object.entries(resellerMarkup).map(([key, value]) => [key, Number(value)]))
        const dict = { name, supplier: 'elephant', supplierName: game, supplierNotes: notes, tagline, gameItems, consumerMarkup, resellerMarkup: convertedMarkup, resellerMarkupAll, markupForIndividualResellers: setForIndividualReseller, requiresServerID, requiresCharacterName,
                        priority: launchedGames.length+1, servers }
        await axios.post('/api/launch_game', dict).then(res => {
            setIsLaunchingGame(false)
            setIsGameLaunched(true)
            setIsGameAlreadyLaunched(true)
        }).catch(err => alert('Error launching game: ' + err))
    }

    const renderCards = () => {
        if (!denoms) return 
        if (!Array.isArray(denoms)) return
        const data = isSearching ? denoms.filter(denoms => denoms.key.toLowerCase()?.includes(searchString.toLowerCase())) : denoms
        const cards = []
        for (const [i, denom] of data.entries()) {
            const amount = isNumeric(denom.value) ? '$' + denom.value?.toFixed(2) : denom.value
            cards.push(<Card key={i} style={{ backgroundColor: '#1b1c1d' }} header={<h4 style={{ color: '#E6E6E6' }}>{denom.key}</h4>} description={<div style={{ color: '#E6E6E6', whiteSpace: 'normal', overflowWrap: 'break-word', wordBreak: 'break-word' }}>{amount}</div>}/>)
        }
        return <CardGroup doubling itemsPerRow={6}>{cards}</CardGroup>
    }
    const renderServers = () => {
        if (!servers) return 'Server list: None'
        const arr = Object.entries(servers).map(([key, value]) => {
            const str = `${key}: ${value}`
            return <div key={key}>{str}</div>
        })
        return <div><h4>Servers:</h4>{arr}</div>
    }

    if (isLoading) return(<Loader active/>)

    return (
        <Container inverted style={{ background: '#1b1c1d' }}>
            <Grid style={{ marginTop: 10, marginBottom: 15 }}>
                <GridColumn floated="left" width={5}>
                    <h1 style={{ color: 'white' }}>{game}</h1>
                </GridColumn>
                <GridColumn width={6}>
                    <Input inverted fluid action={{ icon: 'search', color: 'teal', inverted: true }} placeholder="Search item..." onChange={handleChangeSearchField} style={{ border: '1px #333 solid' }} input={<input style={{ backgroundColor: '#1b1c1d', color: 'white' }} />}/>
                </GridColumn>
                <GridColumn floated="right" width={5}>
                    <Button inverted color='teal' onClick={goBack}><Icon name='reply'/>Back to Games</Button>
                </GridColumn>
            </Grid>
            <Divider inverted style={{ marginTop: 25, marginBottom: 20 }} horizontal><Header inverted as="h4"><Icon inverted name="dollar" />Denominations</Header></Divider>
            {renderCards()}
            <Divider inverted style={{ marginTop: 50, marginBottom: 20 }} horizontal><Header inverted as="h4"><Icon inverted name="info" />Details</Header></Divider>
            <h4>Fields: {fields.join(', ')}</h4>
            {renderServers()}
            <br/><br/>Notes: {notes}<br/>
            {!isGameAlreadyLaunched ? <Button style={{ marginTop: 28 }} inverted color='teal' onClick={handleLaunchGameClicked}>{ isLaunchingGame ? 'Cancel Launch' : 'Launch this Game' }</Button> : isGameLaunched ? null : <h3>This game has been launched ✅</h3> }
            <br/>
            <div id='scrollToHere'>
                {isLaunchingGame ?<GameLaunch supplierName={game} launchGame={handleFinalLaunchClicked}/> : null}
            </div>
            {isGameLaunched ? <Message success header='Game successfully launched!'/> : null}
            { isLaunchingGame ? <Button style={{ marginTop: 45 }} inverted color='teal' onClick={goBack}><Icon name='reply'/>Back to Games</Button> : null }
            <br/><br/><br/><br/><br/>
        </Container>
    )
}

function isNumeric(str) {
    if (typeof str != "string") return false 
    return !isNaN(str) && !isNaN(parseFloat(str)) 
}

function isDevelopmentServer() {
    return process.env.NODE_ENV === 'development'
}

function scrollToElement(elementId) {
    const element = document.getElementById(elementId)
    if (element) {
        element.style.scrollMarginTop = '5rem'
        element.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }
}

export default EDGame